import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const ClearFiltersButton = ({ hasFilters, clearFilters, isMobile = false }) => {
  const { t } = useTranslation(["header-filters"]);
  return (
    <Box
      sx={{
        cursor: hasFilters ? "pointer" : "not-allowed",
      }}
    >
      <Button
        sx={{
          background: "none",
          textDecorationLine: "underline",
          textWrap: "nowrap",
          color: "rgba(47, 43, 61, 0.9)",
          fontSize: 15,
          textTransform: "none",
          pointerEvents: hasFilters ? "auto" : "none",
          ...(isMobile ? { opacity: hasFilters ? 1 : 0.5 } : {}),
        }}
        onClick={clearFilters}
      >
        {t("filters.clear_filters")}
      </Button>
    </Box>
  );
};

export default ClearFiltersButton;
